import _ from 'lodash';
import { decamelizeKeys } from '../../lib';
import {
    RentalChargeSnapshot,
    NewRentalChargeSnapshot,
    SimulationRequestRawArgs,
    RentalResultWithDestination,
    NewRentalInstallmentSnapshot,
} from '../../models/RentalPayment';
import api from '../api';
import { getBackVersion } from '../../config';

const getBillingCharges = (
    contractId: string
): Promise<RentalResultWithDestination<RentalChargeSnapshot[]>> =>
    api.request<RentalResultWithDestination<RentalChargeSnapshot[]>>({
        method: 'GET',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/billing_charges`,
    });

const createBillingCharge = (
    charge: NewRentalChargeSnapshot | RentalChargeSnapshot,
    installments: NewRentalInstallmentSnapshot[] | null | undefined,
    contractId: string
): Promise<RentalChargeSnapshot> =>
    api.request<RentalChargeSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/billing_charges`,
        data: decamelizeKeys({
            ..._.omit(charge, ['id', 'isNew']),
            installments: installments,
        }),
    });

const updateBillingCharge = (
    id: number,
    charge: NewRentalChargeSnapshot | RentalChargeSnapshot,
    installments: NewRentalInstallmentSnapshot[] | null | undefined,
    contractId: string
): Promise<RentalChargeSnapshot> =>
    api.request<RentalChargeSnapshot>({
        method: 'PATCH',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/billing_charges/${id}`,
        data: decamelizeKeys({
            ..._.omit(charge, ['id', 'isNew']),
            installments: installments,
        }),
    });

const removeBillingCharge = (
    id: number,
    contractId: string
): Promise<boolean> =>
    api.request<boolean>({
        method: 'DELETE',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/billing_charges/${id}`,
    });

const simulateBillingCharge = ({
    contractId,
    referenceMonthType,
    monthDueDay,
    contractBeginDate,
    contractEndDate,
    charge,
}: SimulationRequestRawArgs) =>
    api.request<RentalChargeSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/rental/billing_charges/simulation`,
        data: decamelizeKeys({
            ...charge,
            contractId,
            referenceMonthType,
            monthDueDay,
            contractBeginDate,
            contractEndDate,
            configurations: [],
        }),
    });

export {
    createBillingCharge,
    getBillingCharges,
    removeBillingCharge,
    simulateBillingCharge,
    updateBillingCharge,
};
